// src/api/useSignUp.js
import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";

const fetchUpdateStudy = ({ id, ...formData }) => {
  return api.put(`/study/${id}`, formData);
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useUpdateStudyQuery = () => {
  return useMutation({ mutationFn: fetchUpdateStudy });
};
